export const contentTableConfig = {
  title: '老师列表',
  propList: [
    { prop: 'nickName', label: '姓名', minWidth: '120' },
    { prop: 'avatar', label: '头像', minWidth: '90',slotName: 'avatar' },
    { prop: 'teachingAge', label: '教龄', minWidth: '50' },
    { prop: 'idCard', label: '身份证', minWidth: '140' },
    { prop: 'phonenumber', label: '电话', minWidth: '100' },

    { prop: 'address', label: '地址', minWidth: '150' },

    // { prop: 'totalNumber', label: '每月授课课时统计', minWidth: '140' },
    { prop: 'unCreditNum', label: '爽约次数', minWidth: '80' },
    { prop: 'remark', label: '备注', minWidth: '280' },

    { prop: 'approveStatus', label: '审核状态', minWidth: '80',slotName: 'approveStatus' },

    { prop: 'hander', label: '操作', minWidth: '180',slotName: 'operate',fixed: 'right' }
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  showFooter: true
}
